<template>
  <div class="main-container">
    <div class="bread">
      <router-link :to="{ name: 'Index' }">首页</router-link>
      <span class="slash">/</span>
      <span class="current">{{ $route.query.title }}</span>
    </div>
    <Classify
      :items="[
        {
          id: 'classify',
          name: '分类',
          value: { item: search.classify_id },
          children: classifyList,
        },
      ]"
      @change="onClassifyChange"
    ></Classify>
    <list
      ref="list"
      class="list"
      url="/api/app/information/index"
      method="post"
      :search="search"
    >
      <template v-slot="{ list }">
        <div>
          <NewsRecommendItem
            class="news-recommend-item"
            v-for="item in list"
            :key="item.id"
            :item="item"
          ></NewsRecommendItem>
        </div>
        <Empty v-if="list.length == 0" class="empty" title="暂无资讯" />
      </template>
    </list>
  </div>
</template>
<script>
import NewsRecommendItem from "../../components/rich/NewsRecommendItem.vue";
import Classify from "../../components/Classify.vue";
export default {
  name: "NewsRecommend",
  components: {
    NewsRecommendItem,
    Classify,
  },
  data() {
    return {
      search: {
        classify_id: 0,
        recommend: this.$route.params.id,
        status:1
      },
      classifyList: [],
    };
  },
  async created() {
    let classifyList = await this.$http.get("/api/app/information/classify");
    classifyList.unshift({ id: 0, name: "全部" });
    this.classifyList = classifyList;
  },
  methods: {
    onClassifyChange({ value }) {
      this.search.classify_id = value.item;
      this.$refs.list.searchRefresh();
    },
  },
};
</script>
<style lang="scss" scoped>
.list {
  margin: 20px 0 36px 0;
  /deep/ {
    .pager {
      margin-bottom: 45px;
    }
    .news {
      &:last-child {
        margin-bottom: 36px;
      }
    }
  }
  .news-recommend-item {
    border: none;
  }
}
</style>
